import React, { useState } from 'react';
import NotificationMenu from './NotificationMenu';
import './DashboardHeader.css';
import logo from '../../assets/Logo_SALVIR.png';
import logo2 from '../../assets/Logo_SALVIR_letras.png';


const DashboardHeader = ({ toggleSidebar }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
    if (toggleSidebar) {
      toggleSidebar(); // Llamamos la función que controla la sidebar
    }
  };

  return (
    <header className="dashboard-header2">
      {/* Logo */}
      <div className="header-logo">
      <div className="header-logo1">
        <img src={logo} alt="Logo" className="logotipo"   />
        <img src={logo2} alt="Logo2" className="logotipo2" />
        </div>
      </div>

      {/* Menú hamburguesa (solo en móviles) */}
      <button
        className="menu-hamburger"
        onClick={handleMenuToggle}
        aria-label="Abrir menú"
      >
        &#9776; {/* Ícono de menú hamburguesa */}
      </button>

      {/* Notificaciones */}
      <NotificationMenu />
    </header>
  );
};

export default DashboardHeader;
